import { render } from "./UploadVoucher.vue?vue&type=template&id=01df9296&scoped=true"
import script from "./UploadVoucher.vue?vue&type=script&lang=js"
export * from "./UploadVoucher.vue?vue&type=script&lang=js"

import "./UploadVoucher.vue?vue&type=style&index=0&id=01df9296&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01df9296"]])

export default __exports__